import { render } from "./TermsAndConditionForm.vue?vue&type=template&id=7d713bc9&scoped=true"
import script from "./TermsAndConditionForm.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionForm.vue?vue&type=script&lang=js"

import "./TermsAndConditionForm.vue?vue&type=style&index=0&id=7d713bc9&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d713bc9"]])

export default __exports__